// @flow @jsx h

/* eslint-disable compat/compat */

import {
  Figure,
  Quote,
  Paragraph,
  Slideshow,
  Video,
  UnorderedList
} from '@nrk/dh-feature-components'
import { Component, h } from 'preact'
import Skew from '../../../Skew'
import style from '../../index.css'

type Props = any

type State = any

class Section extends Component<Props, State> {
  elm: HTMLDivElement

  constructor () {
    super()

    this.state = {
      didView: false
    }
  }

  componentDidMount () {
    this.props.onRegisterSectionElement(this.props.index, this.elm)
  }

  componentDidUpdate (prevProps: Props) {
    if (
      !this.state.didView &&
      !prevProps.isIntersecting &&
      this.props.isIntersecting
    ) {
      this.props.onAnalyticsEvent({
        action: `section/VIEW/${this.props.index}`
      })

      setTimeout(() => {
        this.setState({ didView: true })
      }, 0)
    }
  }

  render () {
    const {
      index,
      onRegisterTriggerElement,
      value,
      intersectionEntries,
      mediaBaseUrl,
      muted,
      onAnalyticsEvent,
      onToggleMute,
      viewport
    } = this.props

    return (
      <div ref={elm => (this.elm = elm)} className={style.article__section}>
        <Skew className={style.article__sectionSkewTop} position='top' />

        {value.title && (
          <h2
            className={style.article__sectionHeader}
            dangerouslySetInnerHTML={{ __html: value.title }}
          />
        )}

        {value.text.map((item, itemIdx) => {
          switch (item.type) {
            case 'figure':
              return (
                <Figure
                  {...item}
                  key={String(itemIdx)}
                  mediaBaseUrl={mediaBaseUrl}
                />
              )
            case 'quote':
              return (
                <Quote
                  {...item}
                  key={String(itemIdx)}
                  className={style.article__quote}
                />
              )
            case 'text':
              return <Paragraph {...item} key={String(itemIdx)} />
            case 'slideshow':
              return (
                <Slideshow
                  {...item}
                  key={String(itemIdx)}
                  mediaBaseUrl={mediaBaseUrl}
                  viewport={viewport}
                />
              )
            case 'unorderedList':
              return <UnorderedList {...item} key={String(itemIdx)} />
            case 'video':
              return (
                <Video
                  {...item}
                  {...intersectionEntries[itemIdx]}
                  key={String(itemIdx)}
                  mediaBaseUrl={mediaBaseUrl}
                  muted={muted}
                  onAnalyticsEvent={onAnalyticsEvent}
                  onRegisterTriggerElement={elm =>
                    onRegisterTriggerElement(index, itemIdx, elm)
                  }
                  onToggleMute={onToggleMute}
                />
              )
            default:
              return <div key={String(itemIdx)}>item: {item.type}</div>
          }
        })}
        <Skew className={style.article__sectionSkewBottom} position='bottom' />
      </div>
    )
  }
}

export default Section



// WEBPACK FOOTER //
// ./src/v1/components/Article/Content/Section/index.js